import React from 'react';
import iconSrc from 'images/comments-blankstate.svg';

export default prop => (
  <div className="CommentaryBlankSlate">
    <div
      className="CommentaryBlankSlate-icon"
      style={{ background: `url(${iconSrc})` }}
    />
    <h3 className="CommentaryBlankSlate-heading">
      {t('lessons.editor.collaboration.blank_slate.heading')}
    </h3>
    <p>{t('lessons.editor.collaboration.blank_slate.body')}</p>
  </div>
);
